// extracted by mini-css-extract-plugin
export default {"trio":"styles_trio__brsnY","twoBig":"styles_twoBig__mFbkw","reverse":"styles_reverse__V0Npk","two":"styles_two__AZMpO","twoReverse":"styles_twoReverse__gY7hq"};